export const MEDIA_BREAKPOINT_VALUE = {
    S: `320`,
    M: `768`,
    L: `992`,
    XL: `1365`,
    XXL: `1680`,
    XXXL: `1920`,
    XXXXL: `2560`,
};

export const MEDIA_BREAKPOINT_NUMBER = {
    S: Number(MEDIA_BREAKPOINT_VALUE.S),
    M: Number(MEDIA_BREAKPOINT_VALUE.M),
    L: Number(MEDIA_BREAKPOINT_VALUE.L),
    XL: Number(MEDIA_BREAKPOINT_VALUE.XL),
    XXL: Number(MEDIA_BREAKPOINT_VALUE.XXL),
    XXXL: Number(MEDIA_BREAKPOINT_VALUE.XXXL),
    XXXXL: Number(MEDIA_BREAKPOINT_VALUE.XXXXL),
};

export const MEDIA_BREAKPOINT = {
    S: `${MEDIA_BREAKPOINT_VALUE.S}px`,
    M: `${MEDIA_BREAKPOINT_VALUE.M}px`,
    L: `${MEDIA_BREAKPOINT_VALUE.L}px`,
    XL: `${MEDIA_BREAKPOINT_VALUE.XL}px`,
};

export const MQ = {
    FROM_M: `@media (min-width: ${MEDIA_BREAKPOINT_NUMBER.M}px)`,
    FROM_L: `@media (min-width: ${MEDIA_BREAKPOINT_NUMBER.L}px)`,
    FROM_XL: `@media (min-width: ${MEDIA_BREAKPOINT_NUMBER.XL}px)`,
    FROM_XXL: `@media (min-width: ${MEDIA_BREAKPOINT_NUMBER.XXL}px)`,
    FROM_XXXL: `@media (min-width: ${MEDIA_BREAKPOINT_NUMBER.XXXL}px)`,
    FROM_XXXXL: `@media (min-width: ${MEDIA_BREAKPOINT_NUMBER.XXXXL}px)`,
};
